import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  gap: ${pxToRem('28px')};
`;
export const IconGoBack = styled.div`
  position: absolute;
  left: 0;
  top: -${pxToRem('5px')};
  display: flex;
  cursor: pointer;
`;
export const TextBack = styled.button`
  border: none;
  background-color: transparent;
  text-transform: uppercase;
  cursor: pointer;
`;

export const DropdownContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  align-items: center;
  min-height: ${pxToRem('400px')};
`;

export const DataDropDownSiteChangeCorporate = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: ${pxToRem('24px')};
  margin: auto;
  height: ${pxToRem('72px')};
  margin-top: ${pxToRem('24px')};
  border: solid ${pxToRem('2px')} #f0f0f0;
  border-radius: ${pxToRem('36px')};
  padding: ${pxToRem('8px')};
  background-color: ${props => props.theme.colors.white};
  min-height: ${pxToRem('72px')};
  width: ${pxToRem('297px')};

  & > div {
    height: ${pxToRem('56px')};
    border-radius: ${pxToRem('36px')};
    display: flex;
    align-items: center;
    &:hover:not(:last-child),
    &:active:not(:last-child) {
      background-color: ${props => props.theme.colors.blue.five};
    }
  }
`;
